
import { authHeader } from "./authHeaders";
import Constant from "./constant";
import { handleApiResponse } from "./handleApiResponse";
import axios from "axios";

const handleResponse = handleApiResponse.handleResponse;

const services = { };
const getIntFlowId=(id)=>{
if(id){
  return parseInt(id)
}else{
  return(0)
}

}
services.getUserProfile = ()=> {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${Constant.API_URL}/profile/1`, requestOptions).then(
    handleResponse
  );
}
services.getSignedObj= (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/signAstStatus?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};
services.getTenantByTlyfeId= (text) => {
  console.log("text",text)
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenant/search?search=${text}`,
    requestOptions
  ).then(handleResponse);
};


services.downloadTenancyDocumentPack = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/downloadtenacypack/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getDocuments = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/certificates/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getHoldingDeposit = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/deposits/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getBranchBankAccounts = () => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/branchBankAccounts`,
    requestOptions
  ).then(handleResponse);
};

services.getCompanyBranches = () => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/company/branch?withOutPagination=true`,
    requestOptions
  ).then(handleResponse);
};

services.saveBankAccount = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/accounts`,
    requestOptions
  ).then(handleResponse);
}
services.deleteBankAccount = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/accounts/${id}`,
    requestOptions
  ).then(handleResponse);
}
services.getCommonClauses = () => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/common_clauses`,
    requestOptions
  ).then(handleResponse);
};

services.getArchivedFlows  = (pageNO) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(`${Constant.API_URL}/openflow/flow/archived?pageNo=${pageNO}`, requestOptions).then(
    handleResponse
  );
};
services.getCompletedFlows  = (pageNO) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(`${Constant.API_URL}/openflow/flow/completed?pageNo=${pageNO}`, requestOptions).then(
    handleResponse
  );
};

services.getOnboardedTeanants = (pageNO) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(`${Constant.API_URL}/openflow/flows?pageNo=${pageNO}`, requestOptions).then(
    handleResponse
  );
};

services.getTeanants = (ID) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenant/?flow_id=${getIntFlowId(ID)}`,
    requestOptions
  ).then(handleResponse);
};

services.getFlowInfo = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/flow/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getRentalOffers = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/rentaloffer/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getIdentityData = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/verificationreferencing/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.saveIdentityData = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/verificationreferencing/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.saveGurantorInfo = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/add-guarantor/?flow_id=${getIntFlowId(payload.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}

services.addRentalOffer = (payload, id, url) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  let urlData = "/openflow/rental-offer";

  if (url) {
    urlData = url;
  }
  return fetch(
    `${Constant.API_URL}${urlData}?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.getMoveIn = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/movein/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.addMoveIn = (payload) => {
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.MOCKUP_BASEURL}/openflow/movein`,
    requestOptions
  ).then(handleResponse);
}

services.getTenancyInfo = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenancyinformation/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getNHA = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenancyinformation/getNHA/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.archieveFlow = (id) => {
  const requestOptions = {
    method: "POST",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/flow/archive/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.unArchieveFlow = (id) => {
  const requestOptions = {
    method: "POST",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/flow/unarchive/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.addFlowToProperty = (id) => {
  const requestOptions = {
    method: "POST",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/flow/add-to-property/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.deleteFlow  = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/flow/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};
services.deleteRtrDoc  = (payload) => {
  const requestOptions = {
    method: "DELETE",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/deleteVerificationDocument/?flow_id=${payload.flow_id}&document_url=${payload.document_url}&type_of_document=${payload.type_of_document}&open_flow_sub_tenant_id=${payload.open_flow_sub_tenant_id}`,
    requestOptions
  ).then(handleResponse);
};
services.deleteGau  = (payload) => {
  const requestOptions = {
    method: "DELETE",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/remove-guarantor/?flow_id=${payload.flow_id}&openflow_guarantor_id=${payload.openflow_guarantor_id}&force_remove_from_flow=${payload.force_remove_from_flow || true}`,
    requestOptions
  ).then(handleResponse);
};

services.rtrReminder  = (payload,id,url) => {
  const requestOptions = {
    method: "POST",
    headers: {...authHeader(), "Content-Type": "application/json"},
    body: JSON.stringify(payload),
  };
let newUrl ="/openflow/right_to_rent/reminder?"
if(url){
  newUrl=url
}
  return fetch(
    `${Constant.API_URL}${newUrl}flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.deleteAST = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/tenancyinformation/AST/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};
services.deleteBespokeContract = (id,URL) => {
  const requestOptions = {
    method: "DELETE",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };

  return fetch(
    `${Constant.API_URL}/openflow/manualAst?flow_id=${id}&bespoke_contract_url=${URL}`,
    requestOptions
  ).then(handleResponse);
};

services.uploadManualAST = (payload,id) => {
  const requestOptions = {
    method: "POST",
    headers: {...authHeader(), "Content-Type": "application/json"},
    body: JSON.stringify(payload),
  };

  return fetch(
    `${Constant.API_URL}/openflow/uploadManualAst/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.deleteNHA = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: {...authHeader(), "Content-Type": "application/json"},
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenancyinformation/NHA/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.CheckForLisence = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/licencing/councils/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.downloadSignedContract = (id) => {
  return axios.get(
    `${Constant.API_URL}/openflow/signedAgreement?flow_id=${getIntFlowId(id)}`,
    {
      headers: { ...authHeader() },
      responseType: "blob",
    }
  );
};

services.emailContract = (id,data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/email-contract?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getAST = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenancyinformation/generateContract?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.getOpenflowPurchases = (isCommission) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/product/purchases?isCommission=${isCommission}`,
    requestOptions
  ).then(handleResponse);
};

services.getOpenflowInvoices = (isCommission) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/agent/get_invoice_list`,
    requestOptions
  ).then(handleResponse);
};

services.getProtectData = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/protectandsetup/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.buyRentalWarranty = (flowId, isCommission,data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({isCommission,data}),
  };
  return fetch(
    `${Constant.API_URL}/buy-rental-warranty/?flow_id=${getIntFlowId(flowId)}`,
    requestOptions
  ).then(handleResponse);
};

services.getPropertyDetails = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/property/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
};

services.checkWarrantyAvailable = (flowId) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({}),
  };
  return fetch(
    `${Constant.API_URL}/check-warranty-availibility?flow_id=${getIntFlowId(flowId)}`,
    requestOptions
  ).then(handleResponse);
};

services.buyFlowPackage = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL2}/stripe/create-payment`,
    requestOptions
  ).then(handleResponse);
}

services.getOpenFlowDashboardData = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/flows/summary`,
    requestOptions
  ).then(handleResponse);
}

services.signUpOpenflow = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/flow/signup`,
    requestOptions
  ).then(handleResponse);

};

services.getFlowLogs = (flowId) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader() },
  };
  return fetch(`${Constant.API_URL}/openflow/logs?flow_id=${getIntFlowId(flowId)}`, requestOptions).then(
    handleResponse
  );  
}

services.signInToFcc = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/check-digital-ref-availability`,
    requestOptions
  ).then(handleResponse);
};

services.signInToDD = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/newDirectDebit`,
    requestOptions
  ).then(handleResponse);
};

services.getFlowPackages = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL2}/hubflow/packages`,
    requestOptions
  ).then(handleResponse);
};

services.saveProtectData = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/protectandsetup?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.downloadPurchageTable = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/purchases/pdf`,
    requestOptions
  ).then(handleResponse);
}

services.getTdsData = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${Constant.API_URL}/openflow/tds`, requestOptions).then(
    handleResponse
  );
};

services.fullReferencing = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),  };
  return fetch(
    `${Constant.API_URL}/start-full-reference/?flow_id=${getIntFlowId(data.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}

services.getRentalCollectionData = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${Constant.API_URL}/openflow/protectandsetup/rentcollect?flow_id=${getIntFlowId(id)}`, requestOptions).then(
    handleResponse
  );
};

services.saveRentalCollectionData = (id,data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/start-rent-collection?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.postRtrCode = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/approve-rtr-code`,
    requestOptions
  ).then(handleResponse);
}
services.requestdigital = (data,id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/verification/requestdigital/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.addTenancyInfo = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenancyinformation/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.saveMoveinData = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/editMoveInAccount?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.uploadInventoryDocuments = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/uploadInventoryDocuments?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.arrangeCheckIn = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/arrangeCheckIn/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.sendContractDigitally = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/signAstEmbedded/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.sendBespokeContract = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/email-bespoke-contract/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.saveSlectedProperty = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ property_id: payload }),
  };
  return fetch(`${Constant.API_URL}/openflow/flow`, requestOptions).then(
    handleResponse
  );
}
services.validateEmail = (EMAIL) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenant/is_available?email=${EMAIL}`,
    requestOptions
  ).then(handleResponse);
}
services.saveTeanantDetails = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenant?flow_id=${getIntFlowId(payload.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}
services.sendTeanantDetails = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/tenant/send?flow_id=${getIntFlowId(payload.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}
services.requestrighttorent = (payload) => {
  const isObj = typeof payload === 'object' && payload !== null;
  const flowId = isObj ? payload.flow_id : null;
  const appUserId = isObj ? (payload.app_user_id || payload.id) : payload;
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(isObj ? payload : { app_user_id: appUserId }),
  };
  const url = flowId
    ? `${Constant.API_URL}/openflow/request-right-to-rent/?flow_id=${getIntFlowId(flowId)}`
    : `${Constant.API_URL}/openflow/request-right-to-rent?app_user_id=${getIntFlowId(appUserId)}`;
  return fetch(url, requestOptions).then(handleResponse);
}

services.toggleComplete = (URL) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({}),
  };
  return fetch(`${Constant.API_URL}${URL}`, requestOptions).then(
    handleResponse
  );
}

services.confirmDeposit = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/confirmHoldingDeposit?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.revokeConfirmationDeposit = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/requestHoldingDeposit?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.confirmMovin = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/confirmMoveInMonies?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.requestMoveInMonies = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/requestMoveInMonies?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.requestHoldingDeposit = (payload, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/deposit/requestdeposit/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.saveCer = (data, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/certificates/?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.sendCer = (id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/certificates/send?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.buyCer = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/certificates/buy_requests?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.buyCertificate = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/certificatesandinventories/${payload?.certificate_type || 'inventory'}/buy?flow_id=${getIntFlowId(payload?.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}

services.delCer = (data, id) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/certificates/${data}?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.saveHoldingDeposit = (payload, id, isRequest) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  let URL = `${Constant.API_URL}/openflow/deposits/?flow_id=${getIntFlowId(id)}`;
  if (isRequest) {
    URL = `${Constant.API_URL}/openflow/deposits/send-request/?flow_id=${getIntFlowId(id)}`;
  }
  return fetch(URL, requestOptions).then(handleResponse);
}

services.getVerificationReferencing = (payload,id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/uploadVerificationDocument/?flow_id=${getIntFlowId(payload.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}

services.addNRemovedLandlord = (data, id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ ...data ,flow_id:id}),
  };
  return fetch(
    `${Constant.API_URL}/openflow/landlords?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.sendRentalOffer = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/send-rental-offer?flow_id=${getIntFlowId(data?.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}
services.sendHoldingOffer = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/requestHoldingDeposit?flow_id=${getIntFlowId(data?.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}
services.requestMoveInMonies = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/requestMoveInMonies?flow_id=${getIntFlowId(data?.flow_id)}`,
    requestOptions
  ).then(handleResponse);
}

services.openflowBranchNotification = (id, data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data ),
  };
  return fetch(
    `${Constant.API_URL}/branch/${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.getFccBranchCode = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/settings/getFccBranchCode`,
    requestOptions
  ).then(handleResponse);
}
function upload(files, type) {
  var formData = new FormData();
  formData.append("type", type);
  files.forEach((item) => {
    formData.append("files", item);
  });
  
  const requestOptions = {
    method: "POST",
    body: formData
  };
  return fetch(`https://assets.openbrix.co.uk/uploads`, requestOptions).then((response) => {
    return response.text().then((text) => {
      let data = null;

      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          return {
            data: null,
            failed: [
              {
                name: 'Upload',
                message: 'The upload service returned an invalid response.',
              },
            ],
          };
        }
      }

      let data_item = { data: null, failed: null };
      if (data.status) {
        data_item.data = data.data.filter((item) => item.status).map((item) => item.openbrixName);
      } else {
        if (data.message === "Not all files were uploaded") {
          data_item.failed = data.data.filter((item) => !item.status).map((item) => {
            return {
              name: item.name,
              message: item.message,
            };
          });
          data_item.data = data.data.filter((item) => item.status).map((item) => item.openbrixName);
        }
      }
      return data_item;
    });
  });  
}
services.uploadFiles = (files, type)=> {
  return upload(files, type)
}
services.updateFccBranchCode = (branchCode) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({fccBranchCode: branchCode}),
  };
  return fetch(
    `${Constant.API_URL}/openflow/settings/updateFccBranchCode`,
    requestOptions
  ).then(handleResponse);
}
services.sendEmail = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${Constant.API_URL}/openflow/emailEsignatureURL?flow_id=${data?.flow_id}&style=obx`,
    requestOptions
  ).then(handleResponse);
}
services.makeLead = (open_flow_sub_tenant_id,isLandlord,id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
     isLandlord? `${Constant.API_URL}/openflow/landlords/make_lead/${open_flow_sub_tenant_id}?flow_id=${getIntFlowId(id)}`:`${Constant.API_URL}/openflow/tenant/make_lead/${open_flow_sub_tenant_id}?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.deleteUser = (open_flow_sub_tenant_id,isLandlord,id) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
     isLandlord? `${Constant.API_URL}/openflow/landlords/${open_flow_sub_tenant_id}?flow_id=${getIntFlowId(id)}`:
     `${Constant.API_URL}/openflow/tenant/${open_flow_sub_tenant_id}?flow_id=${getIntFlowId(id)}&force_remove_from_flow=true`,
    requestOptions
  ).then(handleResponse);
}

services.getCount = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL2}/hubita/flows`,
    requestOptions
  ).then(handleResponse);
}
services.getTDSSDSACCOUNT = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/branch/settings/get-deposit-account-details`,
    requestOptions
  ).then(handleResponse);
}
services.getTDSDeposit = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/get-tds-deposit?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.getTdsDepositDan = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(
    `${Constant.API_URL}/openflow/get-tds-dan?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.linkSdsAccount = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
  `${Constant.API_URL}/branch/settings/save-deposit-account-details`,
    requestOptions
  ).then(handleResponse);
}

services.deletelinkAccount = (deposit_protection_type) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({deposit_protection_type:deposit_protection_type}),
  };
  return fetch(
    `${Constant.API_URL}/branch/settings/delete-deposit-account-details`,
    requestOptions
  ).then(handleResponse);
}

services.verificationByObx = (payload) => {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ app_user_id: payload.app_user_id }),
  };
  return fetch(
`${Constant.API_URL}/openflow/id_verification_by_obx?flow_id=${payload.flow_id}`,
    requestOptions
  ).then(handleResponse);
}
services.createTdSeposit = (object,id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(object),
  };
  return fetch(
`${Constant.API_URL}/openflow/create-tds-deposit?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}
services.createTdSepositDraft = (object,id) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(object),
  };
  return fetch(
`${Constant.API_URL}/openflow/create-tds-deposit-draft?flow_id=${getIntFlowId(id)}`,
    requestOptions
  ).then(handleResponse);
}

services.getLandlordBankAccounts = (landlordId) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${Constant.API_URL}/landlord/accounts/${landlordId}`, requestOptions).then(handleResponse);
};

services.addLandlordBankAccount = (landlordId, payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(`${Constant.API_URL}/landlord/accounts/${landlordId}`, requestOptions).then(handleResponse);
};

services.editLandlordBankAccount = (accountId, payload) => {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(`${Constant.API_URL}/landlord/accounts/${accountId}`, requestOptions).then(handleResponse);
};

services.deleteLandlordBankAccount = (accountId) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetch(`${Constant.API_URL}/landlord/accounts/${accountId}`, requestOptions).then(handleResponse);
};

services.uploadSupportingDocs = (payload) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/uploadSupportingDocs?flow_id=${getIntFlowId(payload?.flow_id)}`,
    requestOptions
  ).then(handleResponse);
};

services.deleteSupportingDoc = (payload) => {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  return fetch(
    `${Constant.API_URL}/openflow/deleteSupportingDoc?flow_id=${getIntFlowId(payload?.flow_id)}&supporting_docs_url=${payload?.deleteSupportingDoc}`,
    requestOptions
  ).then(handleResponse);
};

services.updateYotiDocSignatureStatus = (flow_id) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${Constant.API_URL}/openflow/updateYotiDocSignatureStatus?flow_id=${getIntFlowId(flow_id)}`,
    requestOptions
  ).then(handleResponse);
};

export const TenantService = services;
